import { render, staticRenderFns } from "./purecab-activated-carbon-filter.vue?vue&type=template&id=550d53a1&"
import script from "./purecab-activated-carbon-filter.vue?vue&type=script&lang=js&"
export * from "./purecab-activated-carbon-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports